import { MonotoneSvgProps } from './types';

export default function HistogramSVG({ primaryColor }: MonotoneSvgProps) {
  return (
    // <!-- Generator: Adobe Illustrator 25.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      xmlSpace="preserve"
    >
      <style type="text/css">
        {/* <!-- svg classes --> */}
        .bar&#123;fill-rule:evenodd;clip-rule:evenodd;&#125;
      </style>
      <g style={{ fill: primaryColor }}>
        <polygon
          id="Bar_1_1_00000158724296834961030700000001810821624615933837_"
          className="bar"
          points="50,450.84 50,427.68 94.01,427.68 
        94.01,450.84 	"
        />
        <polygon
          id="Bar_1_2_00000163752550027795275080000008671219441195112624_"
          className="bar"
          points="100.856,450.84 100.856,404.519 
        144.866,404.519 144.866,450.84 	"
        />
        <polygon
          id="Bar_1_3_00000121267347112862475860000017727987720174827187_"
          className="bar"
          points="151.711,450.84 151.711,354.018 
        195.721,354.018 195.721,450.84 	"
        />
        <polygon
          id="Bar_1_4_00000106866135554065846870000004227265979834416535_"
          className="bar"
          points="202.567,450.84 202.567,269.26 
        246.577,269.26 246.577,450.84 	"
        />
        <polygon
          id="Bar_1_5_00000022553149785444195680000011683108483017037983_"
          className="bar"
          points="253.423,450.84 253.423,155.012 
        297.433,155.012 297.433,450.84 	"
        />
        <polygon
          id="Bar_1_6_00000116197441598282369340000002779051165028743095_"
          className="bar"
          points="304.279,450.84 304.279,49.16 
        348.289,49.16 348.289,450.84 	"
        />
        <polygon
          id="Bar_1_7_00000101785806932407165260000003910997488591449493_"
          className="bar"
          points="355.134,450.84 355.134,233.748 
        399.144,233.748 399.144,450.84 	"
        />
        <polygon
          id="Bar_1_7_00000139996017677963213860000004681298605914236596_"
          className="bar"
          points="405.99,450.84 405.99,294.808 
        450,294.808 450,450.84 	"
        />
      </g>
    </svg>
  );
}
